// Tools page entry. /tools renders the launcher; /tools/<id> renders one tool.
import { TOOLS, HELPER_TOOL } from "../shared/tools-manifest.js";
import { REGISTRY } from "./registry.js";
import { mountLogo } from "../shared/brand.js";
import { record as recordTool } from "../app/tool-recents.js";
import { bump } from "../shared/activity.js";
import { keepFocusVisible } from "../shared/keep-focus-visible.js";

const root = document.getElementById("rv-tools-root");
const nameEl = document.getElementById("rv-tools-name");
const logoEl = document.getElementById("rv-tools-logo");
if (logoEl) mountLogo(logoEl);

const path = location.pathname.replace(/\/+$/, "");
const m = path.match(/^\/tools\/(.+)$/);
const id = m ? decodeURIComponent(m[1]) : null;

function openTool(tid) {
	const url = "/tools/" + tid;
	if (window.parent && window.parent !== window) {
		const name = ([HELPER_TOOL, ...TOOLS].find((t) => t.id === tid) || {}).name || "Tool";
		try { window.parent.postMessage({ type: "revault-open", url, title: name }, location.origin); return; } catch (e) {}
	}
	location.href = url;
}

function renderLauncher() {
	document.title = "Tools - Re:Vault";
	const intro = document.createElement("p");
	intro.className = "rv-tools-intro";
	intro.textContent = "A built-in toolbox - everything runs locally in your browser.";
	// The "never capped" promise; /about says the same. Keep it to what the tools really do.
	const free = document.createElement("p");
	free.className = "rv-tools-intro rv-tools-free";
	free.textContent = "Flashcards and study mode are free, with no daily limits.";
	const grid = document.createElement("div");
	grid.className = "rv-tools-grid";
	const addCard = (t, first) => {
		const card = document.createElement("button");
		card.className = "rv-tool-card"; card.type = "button";
		const icon = document.createElement("div"); icon.className = "rv-tool-card-icon"; icon.innerHTML = t.icon;
		const name = document.createElement("div"); name.className = "rv-tool-card-name"; name.textContent = t.name;
		const blurb = document.createElement("div"); blurb.className = "rv-tool-card-blurb"; blurb.textContent = t.blurb;
		card.append(icon, name, blurb);
		card.addEventListener("click", () => openTool(t.id));
		if (first) grid.prepend(card); else grid.appendChild(card);
	};
	TOOLS.forEach((t) => addCard(t, false));
	root.append(intro, free, grid);
	// The Study Helper card only when the server has it switched on for this browser.
	fetch("/helper/limits", { cache: "no-store", credentials: "omit", headers: helperAuth() }).then((r) => (r.ok ? r.json() : null)).then((j) => { if (j && j.available) addCard(HELPER_TOOL, true); }).catch(() => {});
}

// Mode chips mark the chosen one with .active; mirror that to aria-pressed so the choice is not
// shown by colour alone.
const syncPressed = (b) => b.setAttribute("aria-pressed", b.classList.contains("active") ? "true" : "false");
if (root && typeof MutationObserver !== "undefined") {
	new MutationObserver((list) => {
		for (const m of list) {
			if (m.type === "attributes") { if (m.target.classList && m.target.classList.contains("rv-chip")) syncPressed(m.target); continue; }
			for (const n of m.addedNodes) {
				if (n.nodeType !== 1) continue;
				if (n.classList.contains("rv-chip")) syncPressed(n);
				n.querySelectorAll(".rv-chip").forEach(syncPressed);
			}
		}
	}).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ["class"] });
}

function helperAuth() { try { const j = JSON.parse(localStorage.getItem("revault:account") || "null"); return j && j.token ? { Authorization: "Bearer " + j.token } : {}; } catch (e) { return {}; } }

if (id === "helper") {
	// Its own bundle, loaded only here: the other tools never download any of it.
	if (nameEl) nameEl.textContent = HELPER_TOOL.name;
	document.title = "Study Helper - Re:Vault Tools";
	if (new URLSearchParams(location.search).get("panel") === "1") document.documentElement.classList.add("hp-in-panel");
	else recordTool(id);
	import(__RVM.helperJs).then((m) => m.default(root)).catch(() => { root.textContent = "Study Helper failed to load. Check your connection and try again."; });
} else if (id && REGISTRY[id]) {
	const meta = TOOLS.find((t) => t.id === id);
	if (nameEl) nameEl.textContent = meta ? meta.name : "";
	document.title = (meta ? meta.name : "Tool") + " - Re:Vault Tools";
	recordTool(id); // "Jump back in" on the start page (ids only; paused in incognito)
	// The study ledger, however the tool was opened (card, row, palette, link). Opening the Timer
	// is not studying yet (the card's "Start a 25 min focus" opens it): its finished focus counts.
	if (id !== "timer") bump("t");
	try { REGISTRY[id](root); } catch (e) { root.textContent = "This tool failed to load."; }
} else {
	// The launcher has no tool name; keep a page heading for screen readers.
	if (nameEl) { nameEl.textContent = "All tools"; nameEl.classList.add("rv-sr-only"); }
	renderLauncher();
}

keepFocusVisible();
